const selector = {
    addTag: '.js_action_add_tag',
    btnLostTag: '.js_btn_lost_tag',
    btnFoundTag: '.js_btn_found_tag',
    btnActivateTag: '.js_btn_activate_tag',
    btnDeactivateTag: '.js_btn_deactivate_tag',
    hr: {
        tagType: 'input[name="hr_tag_type"]',
        tagTypeGeaRadio: 'input[name="hr_tag_type"][value="02"]',
        tagTypeQFreeRadio: 'input[name="hr_tag_type"][value="06"]',
        tagTypeGeaContainer: '#hr_gea_container',
        tagTypeQFreeContainer: '#hr_qfree_container',
    },
    modal: {
        add: '#customer_modal_add_tag',
        lostTag: '#customer_modal_lost_tag',
        foundTag: '#customer_modal_found_lost_tag',
        activateTag: '#customer_modal_activate_tag',
        deactivateTag: '#customer_modal_deactivate_tag'
    },
    inputTagId: '#tag_id',
    country: '#userCountry'
};

export { selector };
